import { CheckCircle2, Crown } from "lucide-react";
import { Button } from "./ui/button";
import { FLAGSHIP } from "../mock";

export default function CeramicHighlight() {
  return (
    <section id="flagship-offer" className="relative py-28 md:py-36 overflow-hidden bg-gradient-to-b from-[#120127] via-[#1a0938] to-[#120127] border-y border-jester/30">
      <div className="absolute -top-20 right-1/4 w-[600px] h-[600px] rounded-full bg-jester-purple/15 blur-[140px]" />
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full bg-acid/8 blur-[140px]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Left: copy */}
          <div>
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="text-xs uppercase tracking-[0.3em] text-acid font-label">
                Our Bread &amp; Butter
              </span>
            </div>

            <h2 className="font-display text-5xl md:text-6xl leading-[0.95]">
              Two layers.<br />
              <span className="text-jester">Five years.</span><br />
              <span className="font-marker text-acid text-3xl md:text-4xl inline-block mt-3">
                glass-deep gloss.
              </span>
            </h2>

            <p className="mt-7 text-white/80 text-lg leading-relaxed max-w-lg">
              The hardest Gtechniq base + the slickest Gtechniq top, hand-applied in our
              climate-controlled Mississauga bay. <strong className="text-acid">$550 covers materials only</strong>.
              surface prep ($400+ value), application labor and window coating
              are all included <strong className="text-white">FREE</strong> when we feature your car on our channels.
            </p>

            <ul className="mt-7 grid sm:grid-cols-2 gap-3">
              {FLAGSHIP.features.map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-white/85">
                  <CheckCircle2 className="w-4 h-4 text-acid mt-0.5 flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <span className="text-xs uppercase tracking-[0.2em] text-white/45 font-label">
                    Starting at
                  </span>
                  {FLAGSHIP.regular && (
                    <span className="px-2 py-0.5 rounded-full bg-acid text-[#120127] text-[10px] uppercase tracking-[0.2em] font-label font-bold">
                      Limited offer
                    </span>
                  )}
                </div>
                <div className="flex items-baseline gap-3">
                  <div className="font-stencil text-4xl text-acid">
                    {FLAGSHIP.from}
                  </div>
                  {FLAGSHIP.regular && (
                    <div className="font-stencil text-2xl text-white/40 line-through decoration-acid/70 decoration-2">
                      {FLAGSHIP.regular}
                    </div>
                  )}
                </div>
                {FLAGSHIP.discount && (
                  <div className="text-xs text-white/55 mt-1 font-marker">
                    {FLAGSHIP.discount}
                  </div>
                )}
              </div>
              <Button
                asChild
                className="h-12 bg-acid hover:bg-[#bff020] text-[#120127] font-label tracking-[0.2em] rounded-full px-7 shadow-[0_0_30px_rgba(168,224,0,0.4)]"
              >
                <a href="#contact">Lock In This Price</a>
              </Button>
            </div>
          </div>

          {/* Right: layer diagram with mini cross-section infographic per layer */}
          <div className="relative">
            <div className="absolute inset-0 bg-jester-purple/10 blur-[80px] rounded-full" />
            <div className="relative space-y-4">
              {FLAGSHIP.layers.map((l, i) => (
                <div
                  key={i}
                  className="relative rounded-2xl border border-jester/40 bg-[#0c0119]/80 backdrop-blur-sm p-7 hover-lift group"
                >
                  <div className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-acid text-[#120127] text-[10px] uppercase tracking-[0.2em] font-label font-bold">
                    {l.label}
                  </div>
                  <div className="flex items-start gap-4">
                    {/* Infographic tile. tiny cross-section highlighting THIS layer */}
                    <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-jester-purple to-deep-purple flex flex-col items-center justify-center flex-shrink-0 p-2">
                      <svg viewBox="0 0 40 40" className="w-full h-full" aria-hidden="true">
                        {/* Always-present layers: clear coat / base coat / primer */}
                        <rect x="2" y="30" width="36" height="6" fill="#1f1f1f" rx="1" />
                        <rect x="2" y="24" width="36" height="6" fill="#3a3a3a" rx="1" />
                        <rect x="2" y="18" width="36" height="6" fill="#252525" rx="1" />
                        {/* Layer 01: highlight CSL (red) */}
                        <rect x="2" y="12" width="36" height="6" fill={i === 0 ? "#FF6B6B" : "#451a1a"} rx="1" opacity={i === 0 ? 1 : 0.4} />
                        {/* Layer 02: highlight EXO (acid green) */}
                        <rect x="2" y="6" width="36" height="6" fill={i === 1 ? "#A8E000" : "#2d3a08"} rx="1" opacity={i === 1 ? 1 : 0.4} />
                        {/* Layer 02 only: water beads on top */}
                        {i === 1 && (
                          <>
                            <circle cx="11" cy="3" r="1.6" fill="#62b3ff" />
                            <circle cx="20" cy="3" r="1.6" fill="#62b3ff" />
                            <circle cx="29" cy="3" r="1.6" fill="#62b3ff" />
                          </>
                        )}
                        {/* Layer 01 only: shield indicator */}
                        {i === 0 && (
                          <text x="20" y="16.5" fontSize="3.6" fill="#fff" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="0.6">9H</text>
                        )}
                      </svg>
                      <div className="font-stencil text-[10px] text-acid leading-none mt-1">0{i + 1}</div>
                    </div>
                    <div>
                      <div className="font-display text-2xl text-white">
                        {l.product}
                      </div>
                      <div className="text-xs uppercase tracking-[0.2em] text-acid font-label mt-1">
                        {l.full}
                      </div>
                      <p className="text-white/70 text-sm leading-relaxed mt-3">
                        {l.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              <div className="text-center pt-4">
                <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-acid/40 bg-acid/5">
                  <Crown className="w-4 h-4 text-acid" />
                  <span className="text-sm text-white">
                    {FLAGSHIP.duration} · Manufacturer Warranty
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
